import Socialmediapage from "./socialmediapage";
import Header from "../kavumainpage/Header";
import Footer from "../kavumainpage/Footer";

function CombinedDashboard() {
  return (
    <div className="dashboard-container">

      <Header />

      <main className="main-content container mx-auto px-4 py-6">
        <Socialmediapage />
      </main>

      <Footer />

    </div>
  );
}

export default CombinedDashboard;